var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('landing'),_c('section-2nd'),_c('section-3rd'),_c('section-4th'),_c('section-5th'),_c('section-6th'),_c('section-7th'),_c('section-8th'),_c('chaldalFaq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }